import React, { useState } from "react";
import { IconCoins, IconCreditCard, IconReceipt, IconReportMoney, IconSearch, IconFilter, IconCalendarEvent, IconDotsVertical, IconCheck } from "@tabler/icons-react";

const INITIAL_PAYROLL_DATA = [
  { id: "EMP-001", name: "Sushil Rathore", department: "Human Resources", base: "₹95,000", deductions: "₹5,000", net: "₹90,000", status: "Paid", date: "30 Apr 2026" },
  { id: "EMP-002", name: "Ruchi Rathore", department: "IT & Support", base: "₹1,20,000", deductions: "₹8,500", net: "₹1,11,500", status: "Paid", date: "30 Apr 2026" },
  { id: "EMP-003", name: "Priya Sharma", department: "Engineering", base: "₹85,000", deductions: "₹4,200", net: "₹80,800", status: "Pending", date: "30 Apr 2026" },
  { id: "EMP-004", name: "Rahul Verma", department: "Marketing", base: "₹65,000", deductions: "₹3,000", net: "₹62,000", status: "Paid", date: "30 Apr 2026" },
  { id: "EMP-005", name: "Karan Mehta", department: "Product", base: "₹1,05,000", deductions: "₹6,000", net: "₹99,000", status: "Pending", date: "30 Apr 2026" },
];

export default function Payroll() {
  const [data, setData] = useState(INITIAL_PAYROLL_DATA);
  const [search, setSearch] = useState("");

  const filtered = data.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    p.department.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="w-full mx-auto mt-2 animate-in fade-in duration-300">
      
      {/* Top Header */}
      <div className="flex items-center justify-between mb-4 px-2">
        <div>
          <h1 className="text-2xl font-bold text-[#212121]">Payroll Processing</h1>
          <p className="text-xs text-gray-500 mt-0.5">Calculate net salary, manage deductions, and issue payslips</p>
        </div>
        <div className="flex items-center gap-2">
          <button className="bg-[#FBD037] text-[#212121] px-4 py-2 rounded-xl flex items-center gap-2 text-sm font-semibold hover:bg-[#FACC15] transition shadow-sm">
            <IconCoins size={16} /> Run Payroll
          </button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-5">
        <div className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-[#FBD037]/10 flex items-center justify-center text-[#212121]">
            <IconCoins size={22} />
          </div>
          <div>
            <div className="text-xs text-gray-400">Total Gross Payroll</div>
            <div className="text-lg font-bold text-gray-900">₹4,70,000</div>
          </div>
        </div>

        <div className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-600">
            <IconCreditCard size={22} />
          </div>
          <div>
            <div className="text-xs text-gray-400">Net Disbursed</div>
            <div className="text-lg font-bold text-gray-900">₹4,43,300</div>
          </div>
        </div>

        <div className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center text-red-600">
            <IconReportMoney size={22} />
          </div>
          <div>
            <div className="text-xs text-gray-400">Total Deductions</div>
            <div className="text-lg font-bold text-gray-900">₹26,700</div>
          </div>
        </div>

        <div className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-blue-600">
            <IconReceipt size={22} />
          </div>
          <div>
            <div className="text-xs text-gray-400">Pay Cycle</div>
            <div className="text-lg font-bold text-gray-900">Monthly (Apr 2026)</div>
          </div>
        </div>
      </div>

      {/* Toolbar */}
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4 px-2">
        <div className="flex items-center gap-3">
          <div className="relative">
            <IconSearch size={16} className="absolute left-3 top-2.5 text-gray-400" />
            <input
              type="text"
              placeholder="Search employee..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="pl-9 pr-4 py-2 rounded-xl border border-gray-200 bg-white text-sm outline-none focus:border-gray-300 w-64 shadow-sm"
            />
          </div>
          <button className="border border-gray-200 bg-white text-gray-700 hover:border-[#FBD037] hover:bg-[#FBD037]/10 px-4 py-2 rounded-xl flex items-center gap-2 text-sm font-semibold transition shadow-sm">
            <IconFilter size={16} /> Filter
          </button>
        </div>

        <div className="flex items-center gap-3">
          <button className="border border-gray-200 bg-white text-gray-700 hover:border-[#FBD037] hover:bg-[#FBD037]/10 px-4 py-2 rounded-xl flex items-center gap-2 text-sm font-semibold transition shadow-sm">
            <IconCalendarEvent size={16} /> Pay History
          </button>
        </div>
      </div>

      {/* Grid Container */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse text-sm">
            <thead>
              <tr className="border-b border-gray-100 bg-[#F7F6F2]">
                <th className="px-6 py-4 font-bold text-[#212121]">Employee ID</th>
                <th className="px-6 py-4 font-bold text-[#212121]">Name</th>
                <th className="px-6 py-4 font-bold text-[#212121]">Department</th>
                <th className="px-6 py-4 font-bold text-[#212121]">Base Salary</th>
                <th className="px-6 py-4 font-bold text-[#212121]">Deductions</th>
                <th className="px-6 py-4 font-bold text-[#212121]">Net Payable</th>
                <th className="px-6 py-4 font-bold text-[#212121]">Status</th>
                <th className="px-6 py-4 font-bold text-[#212121] text-center">Payslip</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((item) => (
                <tr key={item.id} className="border-b border-gray-100 hover:bg-gray-50 transition">
                  <td className="px-6 py-4 font-semibold text-gray-900">{item.id}</td>
                  <td className="px-6 py-4 font-medium text-gray-800">{item.name}</td>
                  <td className="px-6 py-4 text-gray-600">{item.department}</td>
                  <td className="px-6 py-4 text-gray-600">{item.base}</td>
                  <td className="px-6 py-4 text-red-500 font-semibold">{item.deductions}</td>
                  <td className="px-6 py-4 text-emerald-600 font-bold">{item.net}</td>
                  <td className="px-6 py-4">
                    <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold ${
                      item.status === "Paid" ? "bg-emerald-50 text-emerald-600 border border-emerald-100" : "bg-amber-50 text-amber-600 border border-amber-100"
                    }`}>
                      {item.status === "Paid" && <IconCheck size={12} />}
                      {item.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <button className="text-xs font-bold text-[#212121] bg-[#FBD037] hover:bg-[#FACC15] px-3 py-1.5 rounded-lg transition shadow-sm">
                      View Slip
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
}
